module.exports = __webpack_public_path__ + "img/warehouse.1883933e.png";